// src/components/ZesnulaOsobaForm.jsx
import React, { useMemo } from "react";
import { useFormData } from "../context/FormDataContext";

const rowStyle = {
  display: "grid",
  gridTemplateColumns: "220px 1fr",
  gap: 12,
  padding: "6px 0",
  borderBottom: "1px dashed #ddd",
};

const labelStyle = {
  fontWeight: 800,
  fontSize: 13,
};

const valueStyle = {
  fontSize: 14,
};

const isEmpty = (v) =>
  v === null || v === undefined || (typeof v === "string" && v.trim() === "");

function Row({ label, value }) {
  // zobrazí i 0 (kdyby někdy bylo), skryje jen null/undefined/"".
  if (isEmpty(value)) return null;

  return (
    <div style={rowStyle}>
      <div style={labelStyle}>{label}</div>
      <div style={valueStyle}>{String(value)}</div>
    </div>
  );
}

function formatDate(v) {
  if (isEmpty(v)) return "";
  const s = String(v);
  const m = s.match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (!m) return s;
  return `${m[3]}.${m[2]}.${m[1]}`;
}

export default function ZesnulaOsobaForm() {
  const { formData } = useFormData();
  const z = formData?.zesnulaOsoba || {};

  const celeJmeno = useMemo(() => {
    return [z.jmeno, z.prijmeni].filter(Boolean).join(" ").trim();
  }, [z.jmeno, z.prijmeni]);

  const trvale = z.trvaleBydliste || z.adresaTrvalehoBydliste || "";

  return (
    <div style={{ padding: 16, maxWidth: 900 }}>
      <h2 style={{ fontSize: 22, fontWeight: 900, marginBottom: 8 }}>
        Zesnulá osoba – přehled (jen pro čtení)
      </h2>

      <div style={{ fontSize: 12, opacity: 0.7, marginBottom: 16 }}>
        Údaje se automaticky přebírají ze záložky <b>Vstupní informace</b>.
      </div>

      {/* 🪪 Identita */}
      <div
        style={{
          border: "1px solid #333",
          borderRadius: 12,
          padding: 12,
          marginBottom: 12,
        }}
      >
        <div style={{ fontWeight: 900, marginBottom: 10 }}>🪪 Identita</div>

        <Row label="Celé jméno" value={celeJmeno || "—"} />
        <Row label="Datum narození" value={formatDate(z.datumNarozeni)} />
        <Row label="Rodné číslo" value={z.rodneCislo} />
        <Row label="Trvalé bydliště" value={trvale} />
      </div>

      {/* 🩺 Úmrtí */}
      <div
        style={{
          border: "1px solid #333",
          borderRadius: 12,
          padding: 12,
          marginBottom: 12,
        }}
      >
        <div style={{ fontWeight: 900, marginBottom: 10 }}>🩺 Úmrtí</div>

        <Row label="Datum úmrtí" value={formatDate(z.datumUmrti)} />
        <Row label="Čas úmrtí" value={z.casUmrti} />
        <Row label="Místo úmrtí" value={z.mistoUmrti} />
        <Row label="Adresa úmrtí" value={z.adresaUmrti} />
      </div>

      {/* 👨‍⚕️ Ohledací list */}
      <div style={{ border: "1px solid #333", borderRadius: 12, padding: 12 }}>
        <div style={{ fontWeight: 900, marginBottom: 10 }}>👨‍⚕️ Ohledací list</div>

        <Row label="Datum prohlídky" value={formatDate(z.datumProhlidky)} />
        <Row label="Čas prohlídky" value={z.casProhlidky} />
        <Row label="Pitva / pitevna" value={z.pitevna} />
        <Row label="Lékař – jméno" value={z.lekarJmeno} />
        <Row label="Lékař – telefon" value={z.lekarTelefon} />
        <Row label="Diagnóza" value={z.diagnoza} />
        <Row label="Infekce / riziko" value={z.infekce} />
        <Row label="Poznámka" value={z.poznamka} />
      </div>
    </div>
  );
}
